var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"zpa-column zpa-tabs",style:({'height': _vm.height + 'px'}),attrs:{"animated":false}},_vm._l((_vm.tabData),function(tab,index){return _c('TabPane',{key:index,attrs:{"label":tab.name,"disabled":tab.disabled}},[_vm._t(tab.component)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }